// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__sAYsD","visible":"Backdrop_visible__1x-io"};